export const setGeneralSetting = "SET_GENERAL_SETTING";

export const toggleSidebarStatus = "TOGGLE_SIDEBAR_STATUS";

export const updateLoginCodeStatus = "UPDATE_LOGIN_CODE_STATUS";
export const updateLoginCodeMessage = "UPDATE_LOGIN_CODE_MESSAGE";
